var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#B6BFE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.34 14.98H11.925V16.195H15.645V17.215H11.925V19H10.545V17.215H9.27V16.195H10.545V14.98H9.27V13.72H10.545V8.5H14.34C15.25 8.5 16.025 8.82 16.665 9.46C17.305 10.09 17.625 10.855 17.625 11.755C17.625 12.655 17.305 13.42 16.665 14.05C16.025 14.67 15.25 14.98 14.34 14.98ZM14.34 9.805H11.925V13.72H14.34C14.85 13.72 15.295 13.53 15.675 13.15C16.055 12.75 16.245 12.285 16.245 11.755C16.245 11.205 16.06 10.745 15.69 10.375C15.31 9.995 14.86 9.805 14.34 9.805Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.741ffdc8fe36092812f115b5aa626f20.svg";
export { ForwardRef as ReactComponent };